import { useAppTranslation } from "@/utils";
import { Button, Card, Flex, Grid, Input, Slider, Typography } from "@payping/web-components";
import { FC, useEffect, useState } from "react";
import { PlanData } from ".";

type Props = {
  onNext: (value: number) => void;
  onPrev: () => void;
  planData: PlanData;
};
const ProfitPercent: FC<Props> = ({ onNext, onPrev, planData }) => {
  const { t } = useAppTranslation();
  const [monthlyProfit, setMonthlyProfit] = useState<number>(0);
  const [yearlyProfit, setYearlyProfit] = useState<string>("0");
  const [profitPercent, setProfitPercent] = useState<number>(0);
  const { xl, lg, md, sm } = Grid.useBreakpoint();

  const onChangePercent = (value: number) => {
    const amount = value <= 5 ? value : 5;
    setProfitPercent(amount);
    setMonthlyProfit(amount);
    const yearlyValue = (amount * 12).toFixed(1);
    setYearlyProfit(yearlyValue);
  };
  useEffect(() => {
    if (planData?.interestRate != null) {
      onChangePercent(planData.interestRate);
    }
  }, [planData]);
  return (
    <Flex vertical gap={"large"} className="tw-w-full tw-max-w-[640px] max-md:tw-max-w-[100%]">
      <Flex vertical gap={"small"}>
        <Typography.Title level={5} className="!tw-m-0">
          {t("shop.bnpl.addInstallmentPlan.steps.ProfitPercent.form.title")}
        </Typography.Title>
        <Typography.Text className="!tw-m-0">
          {t("shop.bnpl.addInstallmentPlan.steps.ProfitPercent.form.description")}
        </Typography.Text>
        <Card.Ant className="tw-mt-2 tw-w-full">
          <div className="tw-w-full">
            <Slider
              value={profitPercent}
              onChange={onChangePercent}
              step={0.1}
              max={5}
              min={0}
              tooltip={{ open: false }}
            />
            <div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-p-1">
              <span className="tw-text-gray-500 tw-text-xs">0%</span>
              <span className="tw-text-gray-500 tw-text-xs">5%</span>
            </div>
          </div>

          <Flex justify="space-between" gap={"middle"} className="tw-mt-5" vertical={!xl && !lg && !md && !sm}>
            <Flex vertical gap={"small"}>
              <Typography.Text className="!tw-m-0">
                {t("shop.bnpl.addInstallmentPlan.steps.ProfitPercent.monthlyProfit")}
              </Typography.Text>
              <Input.Number
                className="tw-w-full tw-text-center"
                style={{ textAlignLast: "center" }}
                inputMode="numeric"
                changeOnWheel={false}
                controls={false}
                separateThousandth
                step={1000}
                value={monthlyProfit}
                onChange={(value: number | null) => {
                  onChangePercent(Number(value));
                }}
                addonAfter={"%"}
              />
            </Flex>
            <Flex vertical gap={"small"}>
              <Typography.Text className="!tw-m-0">
                {t("shop.bnpl.addInstallmentPlan.steps.ProfitPercent.yearlyProfit")}
              </Typography.Text>
              <Input.Number
                className="tw-w-full !tw-text-center"
                style={{ textAlignLast: "center" }}
                readOnly
                disabled
                inputMode="numeric"
                changeOnWheel={false}
                controls={false}
                separateThousandth
                value={yearlyProfit}
                step={1000}
                addonAfter={"%"}
              />
            </Flex>
          </Flex>
        </Card.Ant>
      </Flex>
      <Flex gap={"small"}>
        <Button block={false} onClick={onPrev} className="!tw-px-8" loading={false} type="default">
          {t("common.previousStep")}
        </Button>
        <Button
          block={false}
          disabled={monthlyProfit < 0}
          onClick={() => onNext(monthlyProfit)}
          className="!tw-px-8"
          loading={false}
          type="primary"
        >
          {t("common.saveAndContinue")}
        </Button>
      </Flex>
    </Flex>
  );
};

export default ProfitPercent;
